import { render } from "./ImageLoader.vue?vue&type=template&id=8cf958bc&ts=true"
import script from "./ImageLoader.vue?vue&type=script&lang=ts"
export * from "./ImageLoader.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__